<ct-extraction-dialog
  title="Dokument abschließen"
  (closeDialog)="ref.close({ accept: false })"
  (acceptDialog)="
    ref.close({ accept: true, useExtractedDataForTraining: useExtractedDataForTraining() })
  "
  class="w-1/2">
  <div class="flex w-full flex-col gap-y-5 p-6">
    @for (groupModel of batchFieldGroupModels(); track $index) {
      <div class="flex flex-col gap-y-1">
        <span class="text-lg font-bold underline">{{ groupModel.label }}</span>
        @for (fieldModel of groupModel.fieldModels; track $index) {
          @if (!fieldModel.onlyVisibleInConsolidation) {
            @let fieldValue = this.extractedBatchFields()[fieldModel.key];
            <div class="flex flex-col">
              <div class="flex items-center justify-between">
                <span class="font-bold">{{ fieldModel.label.text }}</span>
                <button class="flex" (click)="onEditFieldPressed(fieldModel.key)">
                  <span class="material-icons">edit</span>
                </button>
              </div>
              @if (fieldValue) {
                <span>{{ fieldValue }}</span>
              } @else {
                <span class="italic"
                  >{{ fieldModel.label.genus === 'F' ? 'Keine' : 'Kein' }}
                  {{ fieldModel.label.text }} extrahiert</span
                >
              }
            </div>
          }
        }
      </div>
    }
    @for (tableModel of tableModels(); track $index) {
      <div class="flex flex-col">
        <div class="flex items-center justify-between">
          <span class="font-bold">{{ tableModel.label }}</span>
          <button class="flex" (click)="onEditFieldPressed(tableModel.fieldModels[0].key)">
            <span class="material-icons">edit</span>
          </button>
        </div>
        @let tableRowCount = extractedRowCountByTableKey()[tableModel.key];
        @if (tableRowCount > 0) {
          <span>{{ tableModel.label }} ({{ tableRowCount }})</span>
        } @else {
          <span class="italic">Keine {{ tableModel.label }} extrahiert</span>
        }
      </div>
    }

    <ct-shared-use-for-training-checkbox
      [appTooltip]="'Manuelle Änderungen können nicht für das Training verwendet werden, daher werden diese herausgefiltert.'"
      [disabled]="false"
      [(isTicked)]="useExtractedDataForTraining" />
  </div>
</ct-extraction-dialog>
